
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"copy (2)","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 274.999 300"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 1662","d":"M165.623 56.25a53.194 53.194 0 0153.126 53.126v128.123h21.874a34.4 34.4 0 0034.376-34.373V34.376A34.4 34.4 0 00240.623 0H84.375a34.4 34.4 0 00-34.376 34.376V56.25zm0 0"}}),_c('path',{attrs:{"data-name":"Path 1663","d":"M0 265.624A34.372 34.372 0 0034.374 300h131.25A34.372 34.372 0 00200 265.624V109.376A34.372 34.372 0 00165.624 75H34.374A34.372 34.372 0 000 109.376zm0 0"}})])
          )
        }
      }
    